"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var colors_config_1 = __importDefault(require("../../../colors.config"));
var ngenius_transaction_status_1 = require("../../api/calls/payment-engine/ngenius_transaction_status");
var get_checked_out_basket_thunk_1 = require("../../reducers/slices/basket/thunks/get_checked_out_basket_thunk");
var symbols_1 = require("../../constants/symbols");
var OutcomePage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var reference = searchParams.get("ref");
    var params = (0, react_router_dom_1.useParams)();
    var actionType = params.actionType;
    var checkout_cookie = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).checkout_cookie;
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var _a = (0, react_1.useState)(null), paymentResponse = _a[0], setPaymentResponse = _a[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        if (!basket) {
            dispatch((0, get_checked_out_basket_thunk_1.get_checked_out_basket_thunk)());
        }
    }, [basket]);
    (0, react_1.useEffect)(function () {
        var intervalId = null;
        if (basket && (basket === null || basket === void 0 ? void 0 : basket._id)) {
            var numTries_1 = 0;
            var checkTransactionStatus = function () {
                if (reference) {
                    //Get Transaction
                    (0, ngenius_transaction_status_1.ngenius_transaction_status)({
                        ref: reference,
                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        var status;
                        return __generator(this, function (_a) {
                            setPaymentResponse(response);
                            status = (response === null || response === void 0 ? void 0 : response.content).status;
                            if (response.success == true && status == "SUCCESS") {
                                clearTimeout(intervalId);
                            }
                            else if (numTries_1 > 5) {
                                setPaymentResponse({
                                    success: false,
                                    content: {
                                        status: "FAILED",
                                    },
                                });
                                clearInterval(intervalId);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
                numTries_1 = numTries_1 + 1;
            };
            intervalId = setInterval(checkTransactionStatus, 5000);
        }
        // Cleanup function to clear the interval on unmount
        return function () { return clearInterval(intervalId); };
    }, [basket]);
    return (react_1.default.createElement("div", { className: "relative" },
        paymentResponse ? (react_1.default.createElement("div", { className: "" }, (function () {
            var _a;
            switch (actionType) {
                case "success":
                    var status_1 = (paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.content).status;
                    switch (status_1) {
                        case "AWAIT":
                            return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" },
                                react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Thank you for placing an order through our online shop!", textColor: "text-white", size: "medium", center: true }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your order is being processed. You will get an email once payment is confirmed", textColor: "text-white", size: "medium", center: true }))));
                            break;
                        case "SUCCESS":
                            return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" },
                                react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your order was placed", textColor: "text-white", size: "3xlarge", center: true }),
                                    react_1.default.createElement("div", { className: "flex flex-col" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Thank you for placing an order through our online shop!", textColor: "text-white", size: "medium", center: true }),
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your order has been received, and will be processed once payment has been confirmed.", textColor: "text-white", size: "medium", center: true })),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "See your order below.", textColor: "text-white", size: "medium", center: true })),
                                react_1.default.createElement("div", { className: " flex justify-center" },
                                    react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "w-[400px] md:w-[600px] lg:w-[800px]\n                             shadow-md shadow-[#404040] border-none", backgroundColor: "bg-white" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order details", textColor: "text-black", size: "large" }),
                                        react_1.default.createElement("div", null, basket &&
                                            basket.product_list.map(function (product, index) {
                                                var _a, _b;
                                                return (react_1.default.createElement("div", { key: index, className: "flex flex-row justify-between" },
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: product.title }),
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                                            symbol: symbols_1.currencySymbol,
                                                            value: (product === null || product === void 0 ? void 0 : product.on_promotion) ? (_a = product === null || product === void 0 ? void 0 : product.promotion_price) === null || _a === void 0 ? void 0 : _a.toString() : (_b = product.price) === null || _b === void 0 ? void 0 : _b.toString(),
                                                        }) })));
                                            })),
                                        react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                                        react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Total" }),
                                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({ symbol: symbols_1.currencySymbol, value: (_a = basket === null || basket === void 0 ? void 0 : basket.total) !== null && _a !== void 0 ? _a : "0", decimalPlaces: 2 }) })),
                                        react_1.default.createElement("div", { className: "pt-8 grid grid-cols-2 gap-4" },
                                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Home", backgroundColor: "bg-primary", onClick: function () {
                                                    navigate("/");
                                                } }),
                                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Orders", backgroundColor: "bg-primary", onClick: function () {
                                                    navigate("/orders");
                                                } }))))));
                            break;
                        case "FAILED":
                            return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" },
                                react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Unfortunately, your order was not placed", textColor: "text-white", size: "3xlarge", center: true }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You can try to refresh this page again. Otherwise, please contact support to resolve this issue.", textColor: "text-white", size: "medium", center: true }))));
                            break;
                        default:
                            return react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" });
                    }
                    break;
                case "CANCELLED":
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your order was cancelled", textColor: "text-white", size: "3xlarge", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You have cancelled your order. .", textColor: "text-white", size: "medium", center: true }))));
                default:
                    return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" },
                        react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Unfortunately, we cannot display this page right now", textColor: "text-white", size: "3xlarge", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Click the button below to see your past orders.", textColor: "text-white", size: "medium", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Orders", borderColor: "border-white", backgroundColor: "bg-primary", onClick: function () {
                                    navigate("/orders");
                                } }))));
            }
        })())) : (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "w-full " },
            react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "xlarge", progressColor: "text-white" })))),
        react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
            react_1.default.createElement("div", { className: "h-72 bg-primary" }),
            react_1.default.createElement("div", { className: "-mt-[1px]" },
                react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: colors_config_1.default.primary }))))));
};
exports.OutcomePage = OutcomePage;
